import { useTranslation } from '@/hooks/useTranslation';
import { useToast } from '@/components/layout/Toast';
import {
  AdminEnterprisesWithLicenseScreenDocument,
  AdminEnterprisesWithoutLicenseScreenDocument,
  useCompanyDeleteMutation,
} from '@/graphql/generated';
import {
  ConfirmationModalType,
  useConfirmationModal,
} from '@/components/modals/ConfirmationModal';
import { Loader } from '@/components/generic/Loader';
import consultingCompanyApi from '@/slices/consultingCompany/consultingCompany.api';

export function DeleteEnterpriseButton({
  enterpriseId,
}: {
  enterpriseId: string;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const { openConfirmationModal } = useConfirmationModal();

  const [deleteMutation, { loading }] = useCompanyDeleteMutation();
  const [refetchConsultingCompany] =
    consultingCompanyApi.endpoints.getConsultingCompanies.useLazyQuery();

  const deleteEnterprise = () => {
    deleteMutation({
      variables: {
        companyId: enterpriseId,
      },
      refetchQueries: [
        AdminEnterprisesWithLicenseScreenDocument,
        AdminEnterprisesWithoutLicenseScreenDocument,
      ],
    })
      .then(() => refetchConsultingCompany())
      .then(() => {
        toast.openToastWithMessage(t('admin:companies.toast.company_deleted'));
      })
      .catch((err) => {
        toast.openToastWithError(err.message);
      });
  };

  return (
    <button
      className="primary danger small"
      disabled={loading}
      onClick={() =>
        openConfirmationModal({
          titleBar: t('global:delete'),
          description: t('project.delete.content'),
          callbackIfConfirmed: deleteEnterprise,
          type: ConfirmationModalType.Danger,
        })
      }
    >
      {loading && <Loader />}
      <div>{t('global:delete')}</div>
    </button>
  );
}
